(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["password"]) return;
  try {
    
  document.addEventListener('click', event => {
    const loginLink = event.target.closest('.password--login');

    if (!loginLink) return;

    const passwordRoot = loginLink.closest('password-element');

    if (!passwordRoot) return;

    const passwordInput = passwordRoot.querySelector('form input[type="password"]');

    passwordRoot.setAttribute('data-show-login', 'true');
    passwordInput?.focus();
  });

  } catch(e) { console.error(e); }
})();
})();
